/**
 * Converts an object to URLSearchParams
 * @param {object} params - The parameters object
 */
export function convertToURLSearchParams(params) {
    const searchParams = new URLSearchParams();

    for (const key in params) {
        if (Object.hasOwn(params, key)) {
            searchParams.append(key, params[key]);
        }
    }
    return searchParams;
}
